import React from 'react';
import { Box, Card, CardActionArea, CardContent, Typography } from '@mui/material';

const DOMAIN_LABEL = { SALES: '영업', ACCOUNT: '회계', QUOTE: '견적', TECH: '기술지원' };

/**
 * 템플릿 고르기 - 도메인별 카드 목록. 검색창을 두지 않는다(R10, 비아이매트릭스 KR10-2014-0043032
 * "템플릿 검색부" 회피). 메뉴 권한 없는 템플릿은 API가 아예 내려주지 않는다.
 */
const TemplatePicker = ({ templates = [], onPick }) => {
  const byDomain = templates.reduce((acc, t) => {
    (acc[t.domainCd] = acc[t.domainCd] || []).push(t);
    return acc;
  }, {});

  if (templates.length === 0) {
    return (
      <Typography color="text.secondary" sx={{ py: 4, textAlign: 'center' }}>
        지금 쓸 수 있는 보고서 템플릿이 없습니다. 관리자에게 메뉴 권한을 요청해주세요.
      </Typography>
    );
  }

  return (
    <Box>
      {Object.entries(byDomain).map(([domainCd, list]) => (
        <Box key={domainCd} sx={{ mb: 2.5 }}>
          <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
            {DOMAIN_LABEL[domainCd] || domainCd}
          </Typography>
          <Box
            sx={{
              display: 'grid',
              gap: 1.5,
              gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },
            }}
          >
            {list.map((t) => (
              <Card key={t.tmplCd} variant="outlined">
                <CardActionArea onClick={() => onPick(t.tmplCd)} sx={{ height: '100%' }}>
                  <CardContent>
                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                      {t.tmplNm}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                      {t.tmplDesc}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default TemplatePicker;
